import { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import { FormCreatableSelect, FormField } from '@/_components';

import { getInterests } from './schema';

import { SectionHeading } from '../../headers';
import { CardContainer, FormLayout } from '../../layout';

export function InterestsSection(props: { disabled: boolean }) {
  const form = useFormContext();
  const interests = form.watch('interests');

  const interestsOption = useMemo(() => getInterests(interests), [interests]);

  return (
    <CardContainer>
      <SectionHeading text="Interests" icon="/images/icons/interests.svg" />
      <FormLayout className="mt-7">
        <FormField
          control={form.control}
          name="interests"
          render={({ field: { value, onChange } }) => (
            <FormCreatableSelect
              {...props}
              isMulti
              isClearable
              value={value}
              onChange={onChange}
              options={interestsOption}
              formItemClassName="col-span-12"
              getOptionLabel={(item) => item.name}
              getNewOptionData={(inputValue: string) => ({ name: inputValue, value: inputValue })}
            />
          )}
        />
      </FormLayout>
    </CardContainer>
  );
}
